module.exports = __webpack_public_path__ + "assets/img/3_1213_big.f07c7d5f.jpg";